/** @jsxImportSource ../../i18n */
import React from 'react';
import { cx } from '../../theme/cx';

const tickerOf = (symbol) => String(symbol || '').split(':')[0].split('_')[0];

const MARK_SIZES = {
  sm: 'h-7 w-7 text-[10px]',
  md: 'h-9 w-9 text-[11px]',
  lg: 'h-12 w-12 text-sm',
};

export const SymbolMark = ({ symbol, size = 'md', className }) => (
  <span aria-hidden="true" className={cx('inline-flex flex-shrink-0 items-center justify-center rounded-control border border-line bg-surface-2 font-semibold tracking-wide text-gold-300 shadow-[inset_0_1px_0_rgb(243_239_230/0.04)]', MARK_SIZES[size] || MARK_SIZES.md, className)}>
    {tickerOf(symbol).slice(0, 2).toUpperCase() || '—'}
  </span>
);

const AVATAR_SIZES = { sm: 'h-8 w-8 text-xs', md: 'h-10 w-10 text-sm', lg: 'h-12 w-12 text-base' };

export const UserAvatar = ({ email, size = 'md', className }) => (
  <span aria-hidden="true" className={cx('inline-flex flex-shrink-0 items-center justify-center rounded-full bg-surface-2 font-display font-medium text-gold-300 ring-1 ring-gold-500/40', AVATAR_SIZES[size] || AVATAR_SIZES.md, className)}>
    {(email || '?').charAt(0).toUpperCase()}
  </span>
);

export const LogoMark = ({ size = 32, className }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} className={cx('flex-shrink-0', className)} aria-hidden="true" focusable="false">
    <rect x="0.5" y="0.5" width="31" height="31" rx="8" style={{ fill: 'rgb(var(--c-surface-1))', stroke: 'rgb(var(--c-gold-500) / 0.45)' }} />
    <path d="M8 24.5H24" strokeLinecap="round" style={{ stroke: 'rgb(var(--c-gold-500) / 0.35)' }} />
    <path d="M8 21.5L13 16.5L17 19L24 11" fill="none" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" style={{ stroke: 'rgb(var(--c-gold-500))' }} />
    <circle cx="24" cy="11" r="1.75" style={{ fill: 'rgb(var(--c-gold-300))' }} />
  </svg>
);

export const Logo = ({ size = 36, withWordmark = true, tagline = true, className }) => (
  <span className={cx('inline-flex items-center gap-3', className)}>
    <LogoMark size={size} />
    {withWordmark && (
      <span className="min-w-0 leading-none">
        <span className="block font-display text-[19px] font-medium tracking-[-0.01em] text-fg">PEA Wallet</span>
        {tagline && <span className="mt-1.5 block text-[10px] font-semibold uppercase tracking-[0.18em] text-gold-400/80">Gestion de patrimoine</span>}
      </span>
    )}
  </span>
);
